module.exports = __webpack_public_path__ + "static/media/cf.4b9387f7.svg";